import { IconWrapper, IStyles, pxToRem, pxTovW } from '@geneo2-web/shared-ui';
import { Box, Divider, Typography } from '@mui/material';

const styles: IStyles = {
  iconDetailsComp: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: { xs: pxToRem(5), md: pxTovW(10) },
  },
  iconAndData: {
    display: 'flex',
    alignItems: 'center',
    gap: { xs: pxToRem(10), md: pxTovW(15) },
  },
};

interface IDetails {
  iconName: string;
  data: string;
  label: string;
  hideDivider?: boolean;
}
export const IconDataWithLabel = (props: IDetails) => {
  const { iconName, data, label, hideDivider } = props;

  return (
    <>
      <Box sx={styles.iconDetailsComp}>
        <Box sx={styles.iconAndData}>
          <IconWrapper
            name={iconName}
            size="large"
            parentFolder="icons"
            type="png"
          />

          <Typography
            variant="h2"
            fontWeight="bold"
            sx={{ fontSize: { xs: pxToRem(16), md: pxTovW(24) } }}
          >
            {data}
          </Typography>
        </Box>

        <Typography variant="h3">{label}</Typography>
      </Box>

      {!hideDivider ? (
        <Divider
          orientation="vertical"
          flexItem
          sx={{ borderRight: '1px dashed rgba(0, 0, 0, 0.12)' }}
        />
      ) : null}
    </>
  );
};
